<template>
  <div id="login" :class="isMobile?'mobile-login':'login'">
    <div class="form_control">
      <input v-model="formData.email" type="email" placeholder="請輸入信箱" class="form_input_email"/>
      <span class="tip" :hidden="tip_email"><img :src="staticUrl+'mobile/Tips.png'" alt>{{ tip_text }}</span>
    </div>
    <div class="form_control">
      <input autocomplete="off" type="tel" v-model="formData.code" placeholder="請輸入驗證碼" class="form_input_code"/>
      <button type="button"  @click="sendCode" :class="{ none: disabled }">
        {{ sendSec>0?sendSec+'秒後再試':'獲取驗證碼' }}
      </button>
      <span class="tip" :hidden="tip_code"><img :src="staticUrl+'mobile/Tips.png'" alt>{{ tip_text }}</span>
    </div>
    <div class="login-button"><button type="button"  @click="loginClick">登入</button></div>
    <div class="login-checkbox">
      <input type="checkbox" value="" @change="checkboxChange">我已閱讀並同意
      <a href="/services" target="_blank">服務條款</a>及<a href="/privacyPolicy" target="_blank">隱私協議</a>
    </div>
    <div class="line" v-if="isMobile"></div>
    <div class="form_control other">
      其他帳號登入：
      <br v-if="isMobile"/>
      <!-- <a @click="loginGoogle" id="loginGoogle"><img :src="staticUrl+'mobile/google-big.png'" alt></a> -->
      <a @click="loginFacebook"><img :src="staticUrl+'mobile/facebook-big.png'" alt></a>
      <a  id='customBtn'>
        <img :src="staticUrl+'mobile/google-big.png'"/>
      </a>
      <!-- <a @click="loginApple"><img :src="staticUrl+'mobile/apple-big.png'" alt></a> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      tip_text: '',
      tip_email: true,
      tip_code: true,
      disabled: false,
      isCheck: false,
      sendSec: 0,
      formData: {
        email: '',
        code: ''
      },
    }
  },
  created () {
  },
  computed: {
    ...mapGetters(['isMobile','staticUrl'])
  },
  mounted() {
    const client = google.accounts.oauth2.initTokenClient({
      client_id: '936962973350-0uk5dq5o1r59rja4odifi8id7344cc55.apps.googleusercontent.com',  //google申 请的appid
      scope:'profile email openid',     //需要google返回的数据
      callback: (response) => {
          console.log(response)
          buttonlogn('2',response.access_token)  //返回给后端access_token
      }, //回调函数
    });
    document.getElementById('customBtn').addEventListener('click',
      function () { client.requestAccessToken() }
    ); //按钮绑定事件
  },
  methods: {
    ...mapActions(['ZhuziUserLogin', 'ZhuziUserLoginFb','EmailLogin','BambooSdkLogin','GetZhuziMycardRoles']),
    loginIn () {
      this.$router.push({ name: 'mobileLogin', query: {} })
    },
    getRoles () {
      this.GetZhuziMycardRoles().then((res) => {
        if (res.msg === 'token已过期,请重新登录') {
          this.goOut()
        }
      })
    },
    sendCode () {
      if (this.formData.email === '') {
        this.showError('請輸入信箱，信箱不能为空')
        return;
      }
      this.disabled = true
      if (this.sendSec > 0) {
        return;
      }
      this.sendSec = 60
      let timeId = setInterval(() => {
        this.sendSec--
        if (this.sendSec <= 0) {
          this.sendSec = 0
          this.disabled = false
          clearInterval(timeId)
        }
      }, 1000)
      this.EmailLogin({ email: this.formData.email }).then(res => {
        this.showSuccess('驗證碼發送成功')
      }).catch(() => {
        this.showError('驗證碼發送失敗，請重確認信箱是否正確！')
      })
    },
    loginClick () {
      if (this.formData.email === '') {
        this.tip_text = '請輸入信箱，信箱不能为空！'
        this.tip_email = false
        return
      } else {
        this.tip_email = true
      }
      if (this.formData.code === '' && this.formData.code.length<4) {
        this.tip_text = '請輸入驗證碼'
        this.tip_code = false
        return
      } else {
        this.tip_code = true
      }
      if (!this.isCheck) {
        this.showError('請確認隱私協議選項內容')
        return
      }
      this.ZhuziUserLogin({ email: this.formData.email, code: this.formData.code }).then(res => {

        res.username = this.formData.email
        this.doBambooLogin(res)
      }).catch(() => {
        this.showError('請重確認驗證碼以及信箱是否正確！')
      })
    },
    loginFacebook () {
      let that = this
      window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          that.doLogin(response.authResponse);
        } else {
          window.FB.login(function (response) {
            if (response.status !== 'connected') {
              that.showError('登入失敗')
              return;
            }
            let res = response.authResponse
            that.ZhuziUserLoginFb({ userId: res.userID, accessToken: res.accessToken }).then((res) => {
              that.doBambooLogin(res)
            }).catch(() => {
              that.showError('請重確認驗證碼以及信箱是否正確！')
            })
          });
        }
      });
    },
    doBambooLogin (params) {
      let that = this
      that.BambooSdkLogin(params).then((res) => {
        that.getRoles()
        that.showSuccess('登入成功')
        that.$router.push({ name: 'index', query: {} })
      }).catch(() => {
        that.showError('登入失敗')
      })
    },
    doLogin (res) {
      let that = this
      that.ZhuziUserLoginFb({ userId: res.userID, accessToken: res.accessToken }).then((res) => {
        that.doBambooLogin(res)
      }).catch(() => {
        that.showError('登入失敗')
      })
    },
    loginGoogle () {
      /*  fn :function 登录回调函数       */
      const google_init=(fn)=>{
        google.accounts.id.initialize({
            client_id: '936962973350-0uk5dq5o1r59rja4odifi8id7344cc55.apps.googleusercontent.com',//客户端ID(创建应用第三步中获得的id)
            callback: fn
        });
        google.accounts.id.renderButton(
          document.getElementById('customBtn'),//自定义按钮
            {}
        );
      }
      //解析token
      const decode_jwt = (token) => {
          var base64Url = token.split('.')[0];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(
            window.atob(base64).split('').map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join('')
          );
          return JSON.parse(jsonPayload);
      };
      const google_load = (response) => {
        console.log(response)
        buttonlogn('2',response.credential)
        const responsePayload = decode_jwt(response.credential);
        console.log(responsePayload)
      };
      google_init(google_load)
    },
    loginApple () {

    },
    checkboxChange (e) {
      this.isCheck = e.target.checked
    }
  }
}
</script>

<style lang="scss">
  .tip{
    padding-left: 16px;
    font-size:12px;
    font-family:SimSun;
    color:rgba(255,64,64,1);
    line-height:30px;
  }
</style>
